module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('message.schedules.example')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.previews), function(preview) {
    return _c('div', {
      key: preview.startTime,
      staticClass: "slot-preview-item col-3"
    }, [_c('div', {
      staticClass: "slot-preview-time-box"
    }, [_vm._v("\n            " + _vm._s(preview.time) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "slot-preview-persons"
    }, _vm._l((_vm.previewIcons), function(bn) {
      return _c('i', {
        key: bn,
        staticClass: "fa fa-male",
        attrs: {
          "aria-hidden": "true"
        }
      })
    })), _vm._v(" "), _c('div', {
      staticClass: "slot-preview-desc"
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('message.schedules.booking_number')) + " " + _vm._s(preview.booking) + " " + _vm._s(_vm.$t('message.schedules.booking_unit')))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53cc07ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkingSlotPreview.vue
// module id = 1010
// module chunks = 1